import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { UserListLastConnectionCell } from './user-list-last-connection.cell';
import { UserListLastConnectionHeader } from './user-list-last-connection.header';

export const UserListLastConnectionColumn: IdentifiedColumnDef<
  GatewayUserModel,
  GatewayUserModel['lastConnection']
> = {
  enableSorting: false,
  header: UserListLastConnectionHeader,
  cell: UserListLastConnectionCell,
};
